import { render, staticRenderFns } from "./SprintlyInput.vue?vue&type=template&id=ebc20f8a&scoped=true"
import script from "./SprintlyInput.vue?vue&type=script&lang=js"
export * from "./SprintlyInput.vue?vue&type=script&lang=js"
import style0 from "./SprintlyInput.vue?vue&type=style&index=0&id=ebc20f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc20f8a",
  null
  
)

export default component.exports